// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__38Lkv","container":"Layout_container__16WeW","top":"Layout_top__3LtGr","middle":"Layout_middle__1LAF8","bottom":"Layout_bottom__2ZrJp"};